/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * DenyBlockSlashIcon
 */
export default class DenyBlockSlashIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M20 19.6c1.9-2 3-4.6 3-7.6 0-6.1-4.9-11-11-11-2.9 0-5.6 1.2-7.6 3-.1 0-.2.1-.3.2-.1.1 0 .2-.1.2C2.1 6.4 1 9 1 12c0 6.1 4.9 11 11 11 2.9 0 5.6-1.2 7.6-3 .1 0 .2-.1.3-.2.1-.1 0-.2.1-.2zm1-7.6c0 2.1-.7 4.1-2 5.6L6.4 5C7.9 3.7 9.9 3 12 3c5 0 9 4 9 9zM3 12c0-2.1.7-4.1 2-5.6L17.6 19c-1.5 1.2-3.5 2-5.6 2-5 0-9-4-9-9z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

